import React, { useMemo } from 'react';
import ReactDOM from 'react-dom';

import { PortalProps } from './types';

const Portal: React.FC<PortalProps> = ({
  root = 'mms--portal-root',
  children,
}) => {
  const portalRoot = useMemo(() => document.getElementById(root), [root]);

  if (portalRoot) {
    return ReactDOM.createPortal(children, portalRoot);
  } else {
    return children as React.ReactElement<any, any>;
  }
};

export default Portal;
